import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from "@angular/common/http";
import {ResponseHandlerInterface} from "../models/ResponseHandlerInterface";
import {JsonapiHandlerService} from "../services/jsonapi.handler.service";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs/internal/Observable";
import {map} from "rxjs/operators";


@Injectable()
export class CirPublicDataInterceptor implements HttpInterceptor {

  private responseHandlers: ResponseHandlerInterface[];

  constructor(private jsonApiHandler: JsonapiHandlerService) {
    this.responseHandlers = [];
    this.responseHandlers.push(this.jsonApiHandler);
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {


    return next.handle(request).pipe(map(event => {
      if (event instanceof HttpResponse) {
        return this.handleResponse(event);
      } else {
        return event;
      }
    }));

  }

  private handleResponse(originalEvent: HttpResponse<any>): HttpEvent<any> {

    let outputEvent: HttpEvent<any>;

    for (const handler in this.responseHandlers) {
      if (this.responseHandlers[handler]) {
        outputEvent = this.responseHandlers[handler].handle(originalEvent);
      }
    }

    return outputEvent || originalEvent;

  }
}
